(ns rothko.theme.sandi.nav
  (:refer-clojure :exclude [rem])
  (:require [garden.units :refer [percent rem]]
            [rothko.theme.sandi.colours :as sandi-colours]
            [rothko.styles.vars.basic :as vars-basic]))

(def nav
  {:horizontal
   {:width (percent 100)}

   :vertical
   {:width "40vw"
    :height (percent 100)
    :flex-direction :column}})

(def nav-item
  {:horizontal
   {:background-color (:grey-10 vars-basic/colours)
    :background-color--disabled (:grey-5 vars-basic/colours)
    :background-color--hover (:grey-20 vars-basic/colours)
    :background-color--active (:grey-20 vars-basic/colours)
    :color (:grey-40 vars-basic/colours)
    :color--active (:grey-60 vars-basic/colours)
    :color--disabled (:grey-30 vars-basic/colours)
    :color--hover (:grey-60 vars-basic/colours)
    :color--text-hover (:grey-60 vars-basic/colours)
    :justify-content :center
    :min-height (rem 6)
    :padding [[(rem 1) (rem 4)]]}

   :vertical
   {:background-color :white
    :background-color--hover (merge (:grey-10 vars-basic/colours) {:alpha 0.65})
    :background-color--selected (:grey-10 vars-basic/colours)
    :border-bottom [[(rem 0.1) :solid (:grey-10 vars-basic/colours)]]
    :color (:grey-80 vars-basic/colours)
    :color--disabled (:grey-10 vars-basic/colours)
    :color--text-hover (:green sandi-colours/colours)
    :font-size (:medium-large vars-basic/font-sizes)
    :color--icon (:green sandi-colours/colours)
    :justify-content :flex-start
    :min-height (rem 6)
    :padding [[(rem 1) (rem 2)]]}})

(def footer-item
  {:horizontal {}

   :vertical
   {:color (:grey-80 vars-basic/colours)
    :color--hover (:green sandi-colours/colours)
    :font-size (:x-small vars-basic/font-sizes)
    :border-top [[(rem 0.1) :solid (:grey-10 vars-basic/colours)]]
    :min-height (rem 0.5)
    :padding [[(rem 0.5) (rem 2)]]}})
